module.exports = __webpack_public_path__ + "site/img/tczh.12276131.png";